import { useEffect } from 'react';
import { useAdminData } from '../../context/SessionContext';
import authServices from '../../services/AuthServices';

export default function DataInitializer() {
    const { services, categories, setServices, setCategories, counties, setCounties  } = useAdminData();

    useEffect(() => {
        const initializeIfNeeded = async () => {
            if (services.length === 0) {
                try {
                    const res = await authServices.getServices();
                    setServices(res.data || []);
                } catch (err) {
                    console.error('Failed to fetch services on init:', err);
                }
            }

            if (categories.length === 0) {
                try {
                    const res = await authServices.getCategories();
                    setCategories(res.data || []);
                } catch (err) {
                    console.error('Failed to fetch categories on init:', err);
                }
            }

            if (counties.length === 0) {
                try {
                    const res = await authServices.getCounties()
                    setCounties(res.data || []);
                } catch (err) {
                    console.error('Failed to fetch categories on init:', err);
                }
            }
        };

        initializeIfNeeded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); 

    return null; 
}